import { __awaiter, __generator } from "tslib";
import { loadBoundCardsApi } from '../../api/load-bound-cards';
import { normalizeMethods } from './utils';
export function loadCards(apiHost, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var cards;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, loadBoundCardsApi(apiHost, options.serviceToken, options.loadSbpTokens)];
                case 1:
                    cards = _a.sent();
                    return [2, normalizeMethods(cards)];
            }
        });
    });
}
